var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutralLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2787 5.15767C11.2296 5.1497 11.1799 5.14603 11.1302 5.14667H2.66446L2.84906 5.06081C3.0295 4.97541 3.19365 4.85918 3.33417 4.71737L5.70818 2.34336C6.02084 2.04489 6.07338 1.56475 5.83267 1.20573C5.55253 0.823142 5.01529 0.740073 4.63268 1.02022C4.60177 1.04286 4.57239 1.06755 4.54478 1.09411L0.251816 5.38708C-0.0836792 5.7222 -0.0839744 6.26582 0.251145 6.60132C0.25136 6.60153 0.251602 6.60177 0.251816 6.60199L4.54478 10.895C4.88055 11.2298 5.42417 11.229 5.75902 10.8933C5.78537 10.8668 5.80998 10.8387 5.83267 10.8091C6.07338 10.4501 6.02084 9.96993 5.70818 9.67146L3.33846 7.29316C3.21249 7.16705 3.06765 7.06131 2.90916 6.97977L2.65159 6.86386H11.083C11.5216 6.88014 11.9064 6.57376 11.9888 6.14264C12.0647 5.67457 11.7468 5.2336 11.2787 5.15767Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralLeftArrow);
export default __webpack_public_path__ + "static/media/neutral-left-arrow.ce67b49e6b935733c134477ea7fc3949.svg";
export { ForwardRef as ReactComponent };